export enum ContentType {
	Image = 'image',
	Widget = 'widget',
	Featured = 'featured',
	Custom = 'custom',
	LandingPage = 'landingPage',
}
